export default class SetPasswordRequest {
    constructor(public password: string) {
    }
}
